import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionIdService } from './session-id.service';
import {environment} from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly sessionIdService: SessionIdService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const sessionId = this.sessionIdService.getSessionId();
    let headerObject: any = {
        'Content-Type': 'application/json',
        'x-session-id': sessionId
      };
    if(req.url.includes(environment.innovate.researchDefender.activityURL)){
      headerObject = {
        'Content-Type': 'application/json'
      }
    }
    const clonedRequest = req.clone({
      setHeaders: headerObject
    });
    return next.handle(clonedRequest);
  }
}